module.exports = __webpack_public_path__ + "static/wesolveproblems-44f48c56c92aeb06ceb5660cab6991f9.jpg";